var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasyProxy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1417,
    height: 842,
    viewBox: "0 0 1417 842",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M934 35C937.314 35 940 37.6863 940 41V69C940 72.3137 937.314 75 934 75H906C902.686 75 900 72.3137 900 69L900 41C900 37.6863 902.686 35 906 35L934 35Z",
    fill: "url(#paint0_linear_5_84)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1323 380C1326.31 380 1329 382.686 1329 386V414C1329 417.314 1326.31 420 1323 420H1295C1291.69 420 1289 417.314 1289 414L1289 386C1289 382.686 1291.69 380 1295 380L1323 380Z",
    fill: "url(#paint1_linear_5_84)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1412.2 700C1414.85 700 1417 702.149 1417 704.8V727.2C1417 729.851 1414.85 732 1412.2 732H1377.6C1376.32 732 1375.1 732.506 1374.2 733.406L1373.61 734.001C1372.71 734.901 1372.2 736.122 1372.2 737.395V757.818C1372.2 759.091 1372.71 760.312 1373.61 761.212L1374.99 762.594C1375.89 763.494 1377.11 764 1378.38 764H1412.2C1414.85 764 1417 766.149 1417 768.8V791.2C1417 793.851 1414.85 796 1412.2 796H1377C1374.35 796 1372.2 793.851 1372.2 791.2V768.428C1372.2 767.254 1371.73 766.128 1370.9 765.297C1370.07 764.467 1368.95 764 1367.77 764H1325.8C1323.15 764 1321 761.851 1321 759.2V736.8C1321 734.149 1323.15 732 1325.8 732L1366.83 732C1368.1 732 1369.32 731.494 1370.22 730.594L1370.79 730.025C1371.69 729.125 1372.2 727.904 1372.2 726.631V704.8C1372.2 702.149 1374.35 700 1377 700H1412.2Z",
    fill: "url(#paint2_linear_5_84)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1253.5 149L1335.61 149C1336.51 149 1337.37 148.642 1338.01 148.006C1338.64 147.369 1339 146.506 1339 145.605L1339 123.5C1339 121.015 1341.01 119 1343.5 119H1364.5C1366.99 119 1369 121.015 1369 123.5V144.5C1369 146.985 1366.99 149 1364.5 149H1342.4C1341.49 149 1340.63 149.358 1339.99 149.994C1339.36 150.631 1339 151.495 1339 152.395V174.5C1339 176.985 1336.99 179 1334.5 179H1253.5C1251.01 179 1249 176.985 1249 174.5L1249 153.5C1249 151.015 1251.01 149 1253.5 149Z",
    fill: "url(#paint3_linear_5_84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.5 89C1281.01 89 1279 91.0147 1279 93.5L1279 114.5C1279 116.985 1281.01 119 1283.5 119L1334.5 119C1336.99 119 1339 116.985 1339 114.5V92.3954C1339 91.4948 1339.36 90.6312 1339.99 89.9945C1340.63 89.3577 1341.49 89 1342.4 89H1364.5C1366.99 89 1369 86.9853 1369 84.5V63.5C1369 61.0147 1366.99 59 1364.5 59L1343.5 59C1341.01 59 1339 61.0147 1339 63.5V85.6054C1339 86.5057 1338.64 87.3691 1338.01 88.0057C1337.37 88.6424 1336.51 89 1335.61 89L1283.5 89Z",
    fill: "url(#paint4_linear_5_84)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3672 490.715C82.1905 491.538 83.3072 492 84.4716 492H115.61C118.034 492 120 493.966 120 496.391V527.61C120 530.035 118.034 532.001 115.61 532.001L84.055 532.001C82.9799 532.001 81.9489 532.428 81.1888 533.188C80.4286 533.948 80.0016 534.979 80.0016 536.054V567.611C80.0016 570.035 78.036 572.001 75.6113 572.001H44.3916C41.9669 572.001 40.0013 570.035 40.0013 567.611V536.472C40.0013 535.308 39.5387 534.191 38.7154 533.368L38.6342 533.287C37.8109 532.463 36.6942 532.001 35.5298 532.001H4.39028C1.96559 532.001 0 530.035 0 527.61V496.391C0 493.966 1.96559 492 4.39028 492H35.2531C36.4174 492 37.5341 491.538 38.3574 490.714L38.7154 490.357C39.5387 489.533 40.0013 488.417 40.0013 487.252V456.39C40.0013 453.966 41.9669 452 44.3915 452H75.6113C78.036 452 80.0016 453.966 80.0016 456.39V487.53C80.0016 488.695 80.4641 489.811 81.2875 490.635L81.3672 490.715ZM78.6356 493.286C77.8122 492.463 76.6955 492 75.5312 492H44.054C42.9789 492 41.9479 492.427 41.1876 493.188C40.4274 493.948 40.0003 494.979 40.0003 496.054V527.531C40.0003 528.695 40.4629 529.812 41.2862 530.635L41.3658 530.715C42.1892 531.538 43.3058 532.001 44.4702 532.001L75.2541 532.001C76.4185 532.001 77.5352 531.538 78.3585 530.715L78.7138 530.36C79.5371 529.536 79.9997 528.42 79.9997 527.255V496.469C79.9997 495.304 79.5371 494.188 78.7138 493.364L78.6356 493.286Z",
    fill: "url(#paint5_linear_5_84)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.447 78.9008C230.744 79.604 229.79 79.9991 228.796 79.9991L116.75 79.9991C114.679 79.9991 113 81.6781 113 83.7491L113 116.249C113 118.32 114.679 119.999 116.75 119.999L228.518 119.999C229.513 119.999 230.466 120.394 231.17 121.097L231.903 121.83C232.606 122.534 233.001 123.487 233.001 124.482L233.001 155.796C233.001 156.79 232.606 157.744 231.903 158.448L231.448 158.902C230.745 159.605 229.791 160 228.797 160L196.751 160C194.68 160 193.001 161.679 193.001 163.75L193.001 196.25C193.001 198.321 194.68 200 196.751 200L229.251 200C231.322 200 233.001 198.321 233.001 196.25L233.001 164.206C233.001 163.211 233.396 162.257 234.099 161.554L234.555 161.098C235.258 160.395 236.212 160 237.207 160L269.251 160C271.322 160 273.001 158.321 273.001 156.25L273.001 124.206C273.001 123.211 273.396 122.257 274.099 121.554L274.555 121.098C275.258 120.395 276.212 120 277.207 120L309.251 120C311.322 120 313.001 118.321 313.001 116.25L313.001 83.75C313.001 81.679 311.322 80 309.251 80L276.929 80C275.934 80 274.98 79.605 274.277 78.9017L274.098 78.7229C273.395 78.0196 273 77.0658 273 76.0713L273 43.7492C273 41.6781 271.321 39.9992 269.25 39.9992L236.928 39.9992C235.933 39.9992 234.979 39.6041 234.276 38.9008L234.099 38.7237C233.396 38.0205 233.001 37.0667 233.001 36.0721L233.001 3.74999C233.001 1.67893 231.322 -5.172e-06 229.251 -5.08147e-06L196.751 -3.66085e-06C194.68 -3.57032e-06 193.001 1.67893 193.001 3.75L193.001 36.25C193.001 38.3211 194.68 40 196.751 40L228.519 40C229.513 40 230.467 40.3951 231.17 41.0983L231.902 41.8295C232.605 42.5328 233 43.4866 233 44.4812L233 75.795C233 76.7896 232.605 77.7434 231.902 78.4466L231.447 78.9008ZM234.098 81.5533C233.395 82.2565 233 83.2103 233 84.2049L233 116.071C233 117.066 233.395 118.02 234.098 118.723L234.277 118.902C234.98 119.605 235.934 120 236.929 120L268.797 120C269.791 120 270.745 119.605 271.448 118.902L271.903 118.448C272.606 117.744 273.001 116.79 273.001 115.796L273.001 84.4821C273.001 83.4875 272.606 82.5337 271.903 81.8304L271.17 81.0975C270.466 80.3942 269.513 79.9991 268.518 79.9991L237.206 79.9991C236.211 79.9991 235.257 80.3942 234.554 81.0975L234.098 81.5533Z",
    fill: "url(#paint6_linear_5_84)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1135.19 296.187C1135.95 295.427 1136.98 295 1138.05 295H1169.61C1172.03 295 1174 293.034 1174 290.609V259.39C1174 256.966 1172.03 255 1169.61 255H1138.39C1135.97 255 1134 256.966 1134 259.39V290.251C1134 291.416 1133.54 292.532 1132.71 293.356L1132.36 293.714C1131.53 294.537 1130.42 295 1129.25 295H1098.39C1095.97 295 1094 296.965 1094 299.39V330.609C1094 333.034 1095.97 334.999 1098.39 334.999H1129.61C1132.03 334.999 1134 333.034 1134 330.609V299.053C1134 297.978 1134.43 296.947 1135.19 296.187Z",
    fill: "url(#paint7_linear_5_84)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.187 803.187C118.947 802.427 119.978 802 121.053 802H152.61C155.034 802 157 800.034 157 797.609V766.39C157 763.966 155.034 762 152.61 762H121.391C118.966 762 117 763.966 117 766.39V797.251C117 798.416 116.538 799.532 115.715 800.356L115.357 800.714C114.533 801.537 113.417 802 112.252 802H81.3902C78.9656 802 77 803.965 77 806.39V837.609C77 840.034 78.9656 841.999 81.3902 841.999H112.609C115.034 841.999 117 840.034 117 837.609V806.053C117 804.978 117.427 803.947 118.187 803.187Z",
    fill: "url(#paint8_linear_5_84)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_84",
    x1: 920,
    y1: 35,
    x2: 920,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_84",
    x1: 1309,
    y1: 380,
    x2: 1309,
    y2: 420,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_84",
    x1: 1369,
    y1: 700,
    x2: 1369,
    y2: 796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_84",
    x1: 1309,
    y1: 59,
    x2: 1309,
    y2: 179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_84",
    x1: 1309,
    y1: 59,
    x2: 1309,
    y2: 179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_84",
    x1: 60,
    y1: 452,
    x2: 60,
    y2: 572.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_84",
    x1: 113,
    y1: 100,
    x2: 313.001,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_84",
    x1: 1134,
    y1: 255,
    x2: 1134,
    y2: 334.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_84",
    x1: 117,
    y1: 762,
    x2: 117,
    y2: 841.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyProxy);
export default __webpack_public_path__ + "static/media/EasyProxy.13c772b8752b44535d32ed68e9a5b984.svg";
export { ForwardRef as ReactComponent };